import { Box } from "@mui/material";

const commonIconSizes = {
  height: { xs: "16px", sm: "16px", md: "18px", lg: "18px", xl: "22px" },
  width: { xs: "16px", sm: "16px", md: "18px", lg: "18px", xl: "22px" },
};

export const GeneratePdfIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2.25V5.25C10.5 5.44891 10.579 5.63968 10.7197 5.78033C10.8603 5.92098 11.0511 6 11.25 6H14.25M14.25 12.5V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V12.5M2.25 10.5H5.25M7.875 10.5H10.125M12.75 10.5H15.75"
        stroke="#F9F9F9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 8.5V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H10.5L14.25 6V8.5"
        stroke="#F9F9F9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileImportIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2V5C12 5.19891 12.079 5.38968 12.2197 5.53033C12.3603 5.67098 12.5511 5.75 12.75 5.75H15.75"
        stroke="#F9F9F9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 9.5V3.5C5.25 3.10218 5.40804 2.72064 5.68934 2.43934C5.97064 2.15804 6.35218 2 6.75 2H12L15.75 5.75V14C15.75 14.3978 15.592 14.7794 15.3107 15.0607C15.0294 15.342 14.6478 15.5 14.25 15.5H10.125M2 14H8.25M8.25 14L6 11.75M8.25 14L6 16.25"
        stroke="#F9F9F9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftRightArrow = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.28223 20C3.73223 20 3.26123 19.804 2.86923 19.412C2.47723 19.02 2.28156 18.5493 2.28223 18V6C2.28223 5.45 2.47823 4.979 2.87023 4.587C3.26223 4.195 3.73289 3.99934 4.28223 4H20.2822C20.8322 4 21.3032 4.196 21.6952 4.588C22.0872 4.98 22.2829 5.45067 22.2822 6V18C22.2822 18.55 22.0862 19.021 21.6942 19.413C21.3022 19.805 20.8316 20.0007 20.2822 20H4.28223ZM4.28223 18H20.2822V6H4.28223V18Z"
        fill="#F9F9F9"
      />
      <path
        d="M8.45814 9.93053L8.54653 9.84215L8.45814 9.75376L8.02657 9.32219L7.93818 9.2338L7.84979 9.32219L5.26037 11.9116L5.17198 12L5.26037 12.0884L7.84979 14.6778L7.93818 14.7662L8.02657 14.6778L8.45814 14.2462L8.54653 14.1579L8.45814 14.0695L6.81883 12.4302L10.8513 12.4301L10.9763 12.4301L10.9763 12.3051V11.6949L10.9763 11.5699L10.8513 11.5699L6.81883 11.5698L8.45814 9.93053ZM16.1729 9.75365L16.0846 9.84204L16.1729 9.93043L17.8122 11.5697L13.6719 11.5697L13.5469 11.5697V11.6947V12.305V12.43L13.6719 12.43L17.8122 12.4301L16.1729 14.0694L16.0846 14.1577L16.1729 14.2461L16.6045 14.6777L16.6929 14.7661L16.7813 14.6777L19.3707 12.0883L19.4591 11.9999L19.3707 11.9115L16.7813 9.32208L16.6929 9.23369L16.6045 9.32208L16.1729 9.75365Z"
        fill="#F9F9F9"
        stroke="#F9F9F9"
        strokeWidth="0.25"
      />
    </svg>
  );
};

export const ScriptBreakdownIcon = () => {
  return (
    <svg
      width="90"
      height="100"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2153 22V6.61538C11.2153 5.39131 11.7016 4.21737 12.5671 3.35181C13.4327 2.48626 14.6066 2 15.8307 2H38.9076L61.9846 25.0769V57.3846C61.9846 58.6087 61.4983 59.7826 60.6327 60.6482C59.7672 61.5137 58.5932 62 57.3692 62H36.125"
        stroke="#6C65D9"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9077 2V25.0769H61.9846"
        stroke="#6C65D9"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9847 55.0768C22.0827 55.0768 26.2154 50.944 26.2154 45.846C26.2154 40.748 22.0827 36.6152 16.9847 36.6152C11.8867 36.6152 7.75391 40.748 7.75391 45.846C7.75391 50.944 11.8867 55.0768 16.9847 55.0768Z"
        stroke="#6C65D9"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 29V36.2857M2 37.5L8.43564 41.1429M2 54.5L8.43564 50.8571M17 63V55.7143M32 54.5L25.5644 50.8571M32 37.5L25.5644 41.1429"
        stroke="#6C65D9"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowDown = () => {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.06752 0C0.643602 0 0.412024 0.494429 0.68341 0.820092L4.61589 5.53907C4.81579 5.77894 5.18421 5.77894 5.38411 5.53907L9.31659 0.820091C9.58798 0.494428 9.3564 0 8.93248 0L1.06752 0Z"
        fill="#6C65D9"
      />
    </svg>
  );
};
export const GrayDot = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 0.5C1.01447 0.5 -0.0701836 2.81578 1.20092 4.34111C2.13719 5.46463 3.86281 5.46463 4.79908 4.34111C6.07018 2.81578 4.98553 0.5 3 0.5Z"
        fill="#606479"
      />
    </svg>
  );
};
export const WhiteDot = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 0.5C1.01447 0.5 -0.0701836 2.81578 1.20092 4.34111C2.13719 5.46463 3.86281 5.46463 4.79908 4.34111C6.07018 2.81578 4.98553 0.5 3 0.5Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};
export const CharacterIcon = () => {
  return (
    <Box sx={commonIconSizes}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.6999 4.5501C2.6999 4.19206 2.84213 3.84868 3.09531 3.5955C3.34848 3.34233 3.69186 3.2001 4.0499 3.2001C4.40794 3.2001 4.75132 3.34233 5.0045 3.5955C5.25767 3.84868 5.3999 4.19206 5.3999 4.5501C5.3999 4.90814 5.25767 5.25152 5.0045 5.50469C4.75132 5.75787 4.40794 5.9001 4.0499 5.9001C3.69186 5.9001 3.34848 5.75787 3.09531 5.50469C2.84213 5.25152 2.6999 4.90814 2.6999 4.5501ZM4.0499 2.6001C3.53273 2.6001 3.03674 2.80554 2.67104 3.17124C2.30535 3.53694 2.0999 4.03293 2.0999 4.5501C2.0999 5.06727 2.30535 5.56326 2.67104 5.92896C3.03674 6.29465 3.53273 6.5001 4.0499 6.5001C4.56707 6.5001 5.06306 6.29465 5.42876 5.92896C5.79446 5.56326 5.9999 5.06727 5.9999 4.5501C5.9999 4.03293 5.79446 3.53694 5.42876 3.17124C5.06306 2.80554 4.56707 2.6001 4.0499 2.6001ZM7.4621 9.5871C7.7849 9.7191 8.1911 9.8001 8.6999 9.8001C9.8285 9.8001 10.4525 9.3993 10.7813 8.9397C10.9528 8.69852 11.0604 8.41776 11.0939 8.1237C11.0969 8.09638 11.0989 8.06896 11.0999 8.0415V8.0001C11.0999 7.88191 11.0766 7.76488 11.0314 7.65568C10.9862 7.54649 10.9199 7.44727 10.8363 7.3637C10.7527 7.28013 10.6535 7.21383 10.5443 7.16861C10.4351 7.12338 10.3181 7.1001 10.1999 7.1001H7.4219C7.5659 7.2741 7.6739 7.4775 7.7369 7.7001H10.1999C10.2795 7.7001 10.3558 7.7317 10.412 7.78797C10.4683 7.84423 10.4999 7.92053 10.4999 8.0001V8.0325L10.4969 8.0625C10.4739 8.25274 10.4038 8.43423 10.2929 8.5905C10.0967 8.8659 9.6707 9.2001 8.6999 9.2001C8.2607 9.2001 7.9331 9.1317 7.6877 9.0315C7.6385 9.1995 7.5671 9.3891 7.4621 9.5871ZM0.899902 8.3001C0.899902 7.98184 1.02633 7.67661 1.25137 7.45157C1.47642 7.22653 1.78164 7.1001 2.0999 7.1001H5.9999C6.31816 7.1001 6.62339 7.22653 6.84843 7.45157C7.07347 7.67661 7.1999 7.98184 7.1999 8.3001V8.3505C7.1999 8.3565 7.1999 8.3643 7.1987 8.3745C7.1914 8.4933 7.17435 8.61129 7.1477 8.7273C7.0967 8.9481 6.9953 9.2433 6.7907 9.5397C6.3701 10.1481 5.5577 10.7001 4.0499 10.7001C2.5421 10.7001 1.7297 10.1481 1.3091 9.5397C1.0876 9.21705 0.949482 8.84456 0.907102 8.4555C0.903517 8.42059 0.901116 8.38557 0.899902 8.3505V8.3001ZM1.4999 8.3361V8.3469L1.5041 8.3967C1.53661 8.68432 1.63921 8.95957 1.8029 9.1983C2.0951 9.6207 2.7077 10.1001 4.0499 10.1001C5.3921 10.1001 6.0047 9.6207 6.2969 9.1983C6.46063 8.95959 6.56324 8.68433 6.5957 8.3967C6.59767 8.38016 6.59887 8.36354 6.5993 8.3469L6.5999 8.3367V8.3001C6.5999 8.14097 6.53669 7.98836 6.42417 7.87583C6.31164 7.76331 6.15903 7.7001 5.9999 7.7001H2.0999C1.94077 7.7001 1.78816 7.76331 1.67564 7.87583C1.56312 7.98836 1.4999 8.14097 1.4999 8.3001V8.3361ZM7.7999 5.0001C7.7999 4.7614 7.89472 4.53248 8.06351 4.3637C8.23229 4.19492 8.46121 4.1001 8.6999 4.1001C8.9386 4.1001 9.16752 4.19492 9.3363 4.3637C9.50508 4.53248 9.5999 4.7614 9.5999 5.0001C9.5999 5.23879 9.50508 5.46771 9.3363 5.63649C9.16752 5.80528 8.9386 5.9001 8.6999 5.9001C8.46121 5.9001 8.23229 5.80528 8.06351 5.63649C7.89472 5.46771 7.7999 5.23879 7.7999 5.0001ZM8.6999 3.5001C8.30208 3.5001 7.92055 3.65813 7.63924 3.93944C7.35794 4.22074 7.1999 4.60227 7.1999 5.0001C7.1999 5.39792 7.35794 5.77945 7.63924 6.06076C7.92055 6.34206 8.30208 6.5001 8.6999 6.5001C9.09773 6.5001 9.47926 6.34206 9.76056 6.06076C10.0419 5.77945 10.1999 5.39792 10.1999 5.0001C10.1999 4.60227 10.0419 4.22074 9.76056 3.93944C9.47926 3.65813 9.09773 3.5001 8.6999 3.5001Z"
          fill="#F9F9F9"
        />
      </svg>
    </Box>
  );
};

export const NoProjectSvg = () => {
  return (
    <svg
      width="90"
      height="60"
      viewBox="0 0 61 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.75">
        <path
          d="M36.1186 36.898H10.0952C8.43806 36.8812 6.88134 36.446 5.51991 35.7039C2.57387 34.0914 0.542882 31.017 0.414551 27.4517H27.4479C27.5037 28.668 27.7771 29.8286 28.2346 30.8943C28.8762 32.3896 29.875 33.6953 31.1248 34.7052C31.8669 35.3022 32.6927 35.7932 33.5854 36.1615C34.3945 36.4907 35.2259 36.792 36.1186 36.898Z"
          fill="#6C64D9"
        />
        <path
          d="M60.5854 4.30711H51.3065L48.5222 10.2829H25.7462C23.8659 10.2829 22.2254 11.2928 21.3327 12.7993C21.1653 13.0783 21.0258 13.3796 20.9142 13.6976C20.7245 14.2333 20.6185 14.808 20.6185 15.405C20.6185 16.002 20.7245 16.5823 20.9142 17.1179C21.0091 17.3802 21.1207 17.6257 21.249 17.8656C21.6842 18.6579 22.3147 19.3219 23.0847 19.785C23.8603 20.2593 24.7698 20.5271 25.7406 20.5271H31.1305C31.3481 20.5271 31.5602 20.5662 31.7499 20.6387C32.1349 20.7838 32.4529 21.0572 32.6538 21.4087C32.8044 21.6653 32.8881 21.9611 32.8881 22.2791C32.8881 22.3851 32.877 22.4911 32.8602 22.5971C32.7207 23.2388 32.6482 23.9083 32.6482 24.5946C32.6482 25.4762 32.7709 26.3243 32.9941 27.1278C34.1826 26.6926 35.1702 25.8389 35.7672 24.7453V24.7397C35.8676 24.5556 35.9569 24.3659 36.035 24.165L36.0852 24.0367C36.2861 23.4899 36.3921 22.8929 36.3921 22.2791C36.3921 21.6653 36.2861 21.0683 36.0852 20.5215C35.8174 19.7906 35.3822 19.1266 34.8298 18.591C34.7071 18.4682 34.5732 18.3566 34.4393 18.245C34.4169 18.2227 34.389 18.206 34.3667 18.1892C34.3165 18.1502 34.2607 18.1111 34.2049 18.0721C34.1882 18.0609 34.1659 18.0442 34.1491 18.033C34.0208 17.9381 33.8869 17.86 33.7418 17.7819C33.4851 17.6368 33.2173 17.5141 32.9328 17.4137C32.3804 17.2184 31.7889 17.1124 31.1696 17.1124H25.7295C24.7865 17.1124 24.0221 16.3479 24.0221 15.405C24.0221 14.462 24.7642 13.7199 25.6904 13.6976H46.9153L46.3183 14.9754L45.7938 16.1024L45.4702 16.7943L45.3195 17.1124L44.9624 17.8768L44.0753 19.7794L43.7293 20.5215L42.0889 24.0367L40.4987 27.4458L39.1094 30.4254L38.412 31.9263L37.9154 32.992L37.1956 34.5264L37.0449 34.8556C36.7827 34.7496 36.526 34.6324 36.275 34.5041C35.2148 33.9796 34.2607 33.2821 33.4293 32.4619C33.1336 32.1662 32.8546 31.8537 32.5924 31.5301C31.6439 30.3417 30.9352 28.9579 30.5447 27.4458C30.4163 26.8265 30.3494 26.1904 30.3494 25.5376C30.3494 25.0299 30.3884 24.5221 30.4721 24.0311H10.9546L12.595 20.5159L13.7835 17.966L14.1852 17.1068L15.7754 13.692L17.3656 10.2773L18.9335 6.91838C18.939 6.90164 18.9502 6.87932 18.9614 6.86258L19.218 6.31019L19.2348 6.27672C19.603 5.56811 20.0494 4.90413 20.5739 4.30711C22.1362 2.51605 24.3903 1.18809 26.8789 0.897949H53.7057C53.9568 0.909108 54.1967 0.937009 54.4367 0.970487C56.4286 1.23273 58.2308 2.10316 59.6592 3.37531C59.994 3.65987 60.3008 3.97233 60.5854 4.30711Z"
          fill="#A09AFB"
        />
        <path
          d="M60.5858 4.30704H51.3069C51.8983 2.8396 53.0254 1.64556 54.4482 0.964844C56.4401 1.22709 58.2424 2.09751 59.6708 3.36966C60 3.66538 60.3068 3.97785 60.5858 4.30704Z"
          fill="#6C64D9"
        />
      </g>
    </svg>
  );
};

export const MaginWand = () => {
  return (
    <svg
      width="41"
      height="49"
      viewBox="0 0 41 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_593_944)">
        <rect x="15" y="15.5" width="18" height="18" rx="3" fill="#252A38" />
        <path
          d="M29.625 22.8384H27.5156V23.5415H29.625V22.8384ZM26.1094 19.3228H25.4062V21.4321H26.1094V19.3228ZM25.4062 27.0571H26.1094V25.2993L25.4062 26.0024V27.0571ZM21.8906 23.5415H22.9453L23.6484 22.8384H21.8906V23.5415ZM27.4235 24.3578L26.9264 24.8549L29.0147 26.9432L29.5118 26.4461L27.4235 24.3578ZM22.5016 19.436L22.0045 19.9331L24.0928 22.0213L24.5899 21.5242L22.5016 19.436ZM29.0372 19.4627L26.6009 21.899L27.098 22.3961L29.5343 19.9598L29.0372 19.4627ZM25.3359 22.2056L26.8125 23.6118L19.9219 30.5728L18.375 29.0962L25.3359 22.2056ZM25.3359 23.1899L23.6484 24.9478L24.0703 25.3696L25.8281 23.6118L25.3359 23.1899Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_593_944"
          x="0"
          y="0.5"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_593_944"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_593_944"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const Characters = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.70039 4.49785C2.70039 4.13981 2.84262 3.79643 3.0958 3.54326C3.34897 3.29008 3.69235 3.14785 4.05039 3.14785C4.40843 3.14785 4.75181 3.29008 5.00498 3.54326C5.25816 3.79643 5.40039 4.13981 5.40039 4.49785C5.40039 4.85589 5.25816 5.19927 5.00498 5.45245C4.75181 5.70562 4.40843 5.84785 4.05039 5.84785C3.69235 5.84785 3.34897 5.70562 3.0958 5.45245C2.84262 5.19927 2.70039 4.85589 2.70039 4.49785ZM4.05039 2.54785C3.53322 2.54785 3.03723 2.7533 2.67153 3.11899C2.30584 3.48469 2.10039 3.98068 2.10039 4.49785C2.10039 5.01502 2.30584 5.51101 2.67153 5.87671C3.03723 6.24241 3.53322 6.44785 4.05039 6.44785C4.56756 6.44785 5.06355 6.24241 5.42925 5.87671C5.79494 5.51101 6.00039 5.01502 6.00039 4.49785C6.00039 3.98068 5.79494 3.48469 5.42925 3.11899C5.06355 2.7533 4.56756 2.54785 4.05039 2.54785ZM7.46259 9.53485C7.78539 9.66685 8.19159 9.74785 8.70039 9.74785C9.82899 9.74785 10.453 9.34705 10.7818 8.88745C10.9533 8.64627 11.0609 8.36551 11.0944 8.07145C11.0974 8.04413 11.0994 8.01672 11.1004 7.98925V7.94785C11.1004 7.82966 11.0771 7.71263 11.0319 7.60344C10.9867 7.49424 10.9204 7.39503 10.8368 7.31146C10.7532 7.22788 10.654 7.16159 10.5448 7.11636C10.4356 7.07113 10.3186 7.04785 10.2004 7.04785H7.42239C7.56639 7.22185 7.67439 7.42525 7.73739 7.64785H10.2004C10.28 7.64785 10.3563 7.67946 10.4125 7.73572C10.4688 7.79198 10.5004 7.86829 10.5004 7.94785V7.98025L10.4974 8.01025C10.4744 8.20049 10.4043 8.38198 10.2934 8.53825C10.0972 8.81365 9.67119 9.14785 8.70039 9.14785C8.26119 9.14785 7.93359 9.07945 7.68819 8.97925C7.63899 9.14725 7.56759 9.33685 7.46259 9.53485ZM0.900391 8.24785C0.900391 7.92959 1.02682 7.62437 1.25186 7.39932C1.47691 7.17428 1.78213 7.04785 2.10039 7.04785H6.00039C6.31865 7.04785 6.62387 7.17428 6.84892 7.39932C7.07396 7.62437 7.20039 7.92959 7.20039 8.24785V8.29825C7.20039 8.30425 7.20039 8.31205 7.19919 8.32225C7.19189 8.44105 7.17483 8.55905 7.14819 8.67505C7.09719 8.89585 6.99579 9.19105 6.79119 9.48745C6.37059 10.0959 5.55819 10.6479 4.05039 10.6479C2.54259 10.6479 1.73019 10.0959 1.30959 9.48745C1.08809 9.16481 0.94997 8.79231 0.907591 8.40325C0.904005 8.36834 0.901604 8.33332 0.900391 8.29825V8.24785ZM1.50039 8.28385V8.29465L1.50459 8.34445C1.5371 8.63207 1.6397 8.90732 1.80339 9.14605C2.09559 9.56845 2.70819 10.0479 4.05039 10.0479C5.39259 10.0479 6.00519 9.56845 6.29739 9.14605C6.46112 8.90735 6.56373 8.63209 6.59619 8.34445C6.59816 8.32792 6.59936 8.3113 6.59979 8.29465L6.60039 8.28445V8.24785C6.60039 8.08872 6.53718 7.93611 6.42465 7.82359C6.31213 7.71107 6.15952 7.64785 6.00039 7.64785H2.10039C1.94126 7.64785 1.78865 7.71107 1.67613 7.82359C1.5636 7.93611 1.50039 8.08872 1.50039 8.24785V8.28385ZM7.80039 4.94785C7.80039 4.70916 7.89521 4.48024 8.06399 4.31146C8.23278 4.14267 8.4617 4.04785 8.70039 4.04785C8.93909 4.04785 9.168 4.14267 9.33679 4.31146C9.50557 4.48024 9.60039 4.70916 9.60039 4.94785C9.60039 5.18655 9.50557 5.41546 9.33679 5.58425C9.168 5.75303 8.93909 5.84785 8.70039 5.84785C8.4617 5.84785 8.23278 5.75303 8.06399 5.58425C7.89521 5.41546 7.80039 5.18655 7.80039 4.94785ZM8.70039 3.44785C8.30257 3.44785 7.92103 3.60589 7.63973 3.88719C7.35843 4.1685 7.20039 4.55003 7.20039 4.94785C7.20039 5.34568 7.35843 5.72721 7.63973 6.00851C7.92103 6.28982 8.30257 6.44785 8.70039 6.44785C9.09822 6.44785 9.47975 6.28982 9.76105 6.00851C10.0424 5.72721 10.2004 5.34568 10.2004 4.94785C10.2004 4.55003 10.0424 4.1685 9.76105 3.88719C9.47975 3.60589 9.09822 3.44785 8.70039 3.44785Z"
        fill="#606479"
      />
    </svg>
  );
};

export const Camera = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.36961 7.41162C2.34207 7.41168 2.31482 7.41716 2.2894 7.42776C2.26399 7.43835 2.24091 7.45384 2.22148 7.47336C2.20205 7.49287 2.18666 7.51602 2.17618 7.54148C2.1657 7.56694 2.16033 7.59422 2.16039 7.62175V11.0931C2.16039 11.2092 2.25399 11.3032 2.36961 11.3032H8.4107C8.46623 11.303 8.5194 11.2807 8.55853 11.2413C8.59767 11.2019 8.61958 11.1486 8.61946 11.0931V7.62175C8.61958 7.56622 8.59767 7.51291 8.55853 7.47352C8.5194 7.43412 8.46623 7.41186 8.4107 7.41162H2.36961ZM8.4107 6.78214C8.87226 6.78214 9.24665 7.1579 9.24665 7.62175V11.0931C9.24665 11.5565 8.87226 11.9327 8.4107 11.9327H2.36961C2.25955 11.9325 2.15061 11.9106 2.049 11.8683C1.9474 11.826 1.85512 11.7641 1.77745 11.6862C1.69978 11.6082 1.63823 11.5157 1.59632 11.4139C1.55441 11.3122 1.53296 11.2031 1.53321 11.0931V7.62175C1.53321 7.1579 1.90759 6.78214 2.36961 6.78214H8.4107ZM10.4671 8.57882V10.1764C10.4671 10.376 10.2849 10.5251 10.0904 10.4847L9.43291 10.3489V9.70565L9.83987 9.79007V8.96789L9.43291 9.0546V8.4109L10.0881 8.27096C10.1338 8.26125 10.1812 8.26189 10.2267 8.27284C10.2721 8.28378 10.3146 8.30476 10.3509 8.33422C10.3873 8.36369 10.4165 8.40091 10.4366 8.44315C10.4567 8.48539 10.4671 8.53204 10.4671 8.57882ZM3.8332 8.78391C3.37118 8.78391 2.9968 9.16013 2.9968 9.62352C2.9968 10.0869 3.37118 10.4631 3.8332 10.4631C4.29522 10.4631 4.6696 10.0869 4.6696 9.62352C4.6696 9.16013 4.29522 8.78391 3.8332 8.78391ZM3.8332 9.20371C4.06398 9.20371 4.25117 9.39183 4.25117 9.62352C4.25129 9.67853 4.24058 9.73303 4.21964 9.78389C4.1987 9.83476 4.16794 9.88101 4.12913 9.91999C4.09032 9.95897 4.04421 9.98993 3.99343 10.0111C3.94265 10.0323 3.88821 10.0432 3.8332 10.0433C3.77815 10.0433 3.72365 10.0324 3.67282 10.0112C3.622 9.99009 3.57583 9.95914 3.53697 9.92015C3.49811 9.88116 3.46731 9.8349 3.44635 9.784C3.42538 9.7331 3.41465 9.67857 3.41477 9.62352C3.41477 9.39137 3.60196 9.20371 3.8332 9.20371ZM7.35958 3.02881C7.59341 3.02923 7.82488 3.0757 8.04075 3.16558C8.25662 3.25545 8.45268 3.38697 8.61773 3.55261C8.78278 3.71826 8.91358 3.91479 9.00268 4.13098C9.09177 4.34718 9.13741 4.57881 9.13699 4.81264C9.13747 5.04652 9.09188 5.2782 9.00281 5.49445C8.91374 5.7107 8.78295 5.90728 8.61789 6.07297C8.45284 6.23867 8.25676 6.37022 8.04086 6.46013C7.82495 6.55003 7.59345 6.59652 7.35958 6.59694C7.12574 6.59646 6.89429 6.54992 6.67844 6.45999C6.46259 6.37006 6.26657 6.2385 6.10156 6.07281C5.93656 5.90713 5.8058 5.71056 5.71676 5.49434C5.62772 5.27812 5.58214 5.04648 5.58262 4.81264C5.58177 4.34047 5.76849 3.88729 6.10172 3.55277C6.43495 3.21825 6.88741 3.02978 7.35958 3.02881ZM7.36004 3.65829C7.20875 3.65859 7.059 3.68869 6.91934 3.74686C6.77968 3.80504 6.65284 3.89015 6.54608 3.99734C6.43931 4.10453 6.35471 4.23171 6.29709 4.3716C6.23947 4.51149 6.20997 4.66135 6.21027 4.81264C6.20997 4.96394 6.23947 5.1138 6.29709 5.25369C6.35471 5.39358 6.43931 5.52076 6.54608 5.62795C6.65284 5.73514 6.77968 5.82025 6.91934 5.87843C7.059 5.9366 7.20875 5.9667 7.36004 5.967C7.51137 5.96676 7.66117 5.93671 7.80088 5.87856C7.94059 5.82041 8.06748 5.73531 8.17429 5.62811C8.28111 5.52091 8.36576 5.39372 8.4234 5.2538C8.48105 5.11388 8.51057 4.96397 8.51026 4.81264C8.51057 4.66132 8.48105 4.51141 8.4234 4.37149C8.36576 4.23157 8.28111 4.10438 8.17429 3.99718C8.06748 3.88998 7.94059 3.80488 7.80088 3.74673C7.66117 3.68858 7.51137 3.65853 7.36004 3.65829Z"
        fill="#606479"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.41485 3.71191C3.60094 3.71225 3.78514 3.74924 3.95693 3.82077C4.12872 3.89231 4.28473 3.99698 4.41606 4.12882C4.54739 4.26066 4.65146 4.41707 4.72233 4.58914C4.7932 4.7612 4.82948 4.94554 4.82909 5.13163C4.82943 5.31771 4.7931 5.50204 4.72219 5.67409C4.65127 5.84614 4.54716 6.00253 4.4158 6.13433C4.28444 6.26613 4.1284 6.37077 3.95659 6.44226C3.78478 6.51375 3.60058 6.55069 3.41449 6.55098C3.03892 6.55011 2.67907 6.40015 2.41401 6.13407C2.14896 5.86799 2.0004 5.50756 2.00098 5.13199C2.00055 4.94594 2.03677 4.76162 2.10757 4.58956C2.17837 4.4175 2.28237 4.26107 2.41363 4.12921C2.54488 3.99734 2.70083 3.89262 2.87255 3.82102C3.04428 3.74942 3.2288 3.71235 3.41485 3.71191ZM3.06428 4.28321C3.1755 4.2369 3.29475 4.21297 3.41522 4.21277C3.53558 4.21297 3.6544 4.23687 3.76553 4.28311C3.87679 4.3294 3.97783 4.39717 4.06286 4.48255C4.1479 4.56793 4.21527 4.66923 4.26112 4.78067C4.30697 4.89211 4.33039 5.01149 4.33006 5.13199C4.3303 5.2524 4.30681 5.37168 4.26094 5.48301C4.21508 5.59434 4.14772 5.69554 4.06273 5.78084C3.97774 5.86613 3.87678 5.93384 3.76562 5.98011C3.65445 6.02638 3.53526 6.05029 3.41485 6.05048C3.29448 6.05024 3.17532 6.02629 3.0642 5.98001C2.95308 5.93372 2.85216 5.866 2.76721 5.78071C2.68226 5.69542 2.61494 5.59423 2.56909 5.48292C2.52325 5.37162 2.49978 5.25237 2.50002 5.13199C2.49968 5.01152 2.52309 4.89217 2.56892 4.78075C2.61474 4.66934 2.68208 4.56805 2.76708 4.48268C2.85208 4.39731 2.95307 4.32953 3.06428 4.28321Z"
        fill="#606479"
      />
    </svg>
  );
};

export const PreviousIcon = () => {
  return (
    <svg
      width="32"
      height="8"
      viewBox="0 0 32 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31 4.5C31.2761 4.5 31.5 4.27614 31.5 4C31.5 3.72386 31.2761 3.5 31 3.5V4.5ZM0.646444 3.64645C0.451183 3.84171 0.451183 4.15829 0.646444 4.35355L3.82842 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.73079 7.34027 4.73079 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.73079 0.976311 4.73079 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82842 0.464466L0.646444 3.64645ZM31 3.5L0.999998 3.5V4.5L31 4.5V3.5Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};

export const NextIcon = () => {
  return (
    <svg
      width="32"
      height="8"
      viewBox="0 0 32 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM31.3536 4.35355C31.5488 4.15829 31.5488 3.84171 31.3536 3.64644L28.1716 0.464464C27.9763 0.269202 27.6597 0.269202 27.4645 0.464464C27.2692 0.659726 27.2692 0.976308 27.4645 1.17157L30.2929 4L27.4645 6.82842C27.2692 7.02369 27.2692 7.34027 27.4645 7.53553C27.6597 7.73079 27.9763 7.73079 28.1716 7.53553L31.3536 4.35355ZM1 4.5L31 4.5L31 3.5L1 3.5L1 4.5Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};

export const SelectedCircleIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2.5" width="4" height="4" rx="2" fill="#6C65D9" />
      <rect x="0.5" y="1" width="7" height="7" rx="3.5" stroke="#6C65D9" />
    </svg>
  );
};

export const ScriptIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9321 2.79102H4.06738C2.96281 2.79102 2.06738 3.68645 2.06738 4.79102V13.1816C2.06738 14.2861 2.96281 15.1816 4.06738 15.1816H13.9321C15.0367 15.1816 15.9321 14.2861 15.9321 13.1816V4.79102C15.9321 3.68645 15.0367 2.79102 13.9321 2.79102Z"
        stroke="#F9F9F9"
      />
      <path
        d="M3.93945 9.92188H8.42902M8.42902 12.5469H3.93945"
        stroke="#F9F9F9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.93945 7.19238V4.81152C3.93945 4.74249 3.99542 4.68652 4.06445 4.68652H13.916C13.9851 4.68652 14.041 4.74249 14.041 4.81152V7.19238C14.041 7.26142 13.9851 7.31738 13.916 7.31738H4.06445C3.99542 7.31738 3.93945 7.26142 3.93945 7.19238Z"
        stroke="#F9F9F9"
      />
      <path
        d="M10.6836 12.7969V9.67188C10.6836 9.60284 10.7396 9.54688 10.8086 9.54688H13.9156C13.9847 9.54688 14.0406 9.60284 14.0406 9.67187V12.7969C14.0406 12.8659 13.9847 12.9219 13.9156 12.9219H10.8086C10.7396 12.9219 10.6836 12.8659 10.6836 12.7969Z"
        stroke="#F9F9F9"
      />
    </svg>
  );
};

export const BreakdownIcon = () => {
  return (
    <Box sx={commonIconSizes}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 2.25V5.25C10.5 5.44891 10.579 5.63968 10.7197 5.78033C10.8603 5.92098 11.0511 6 11.25 6H14.25M14.25 13.5V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V13.5M2.25 10.5H4.5M7.875 10.5H10.125M13.5 10.5H15.75"
          stroke="#F9F9F9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 7.5V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H10.5L14.25 6V7.5"
          stroke="#F9F9F9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
};

export const SelectedDotIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_560_1175)">
        <circle cx="5" cy="4.5" r="1.5" fill="#6C65D9" />
      </g>
      <circle cx="5" cy="4.5" r="1.5" fill="#6C65D9" />
      <defs>
        <filter
          id="filter0_f_560_1175"
          x="0.5"
          y="0"
          width="9"
          height="9"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_560_1175"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const SelectedRadioIcon = () => {
  return (
    <Box sx={commonIconSizes}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2.5" width="8" height="8" rx="4" fill="#6C65D9" />
        <rect x="0.5" y="1" width="11" height="11" rx="5.5" stroke="#6C65D9" />
      </svg>
    </Box>
  );
};

export const CheckMarkIcon = () => {
  return (
    <Box sx={commonIconSizes}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="1" width="9" height="9" rx="4.5" fill="#252A38" />
        <path
          d="M4.04355 6.60107L3.07358 5.56718C3.00141 5.49025 2.90225 5.44586 2.79755 5.44586C2.69284 5.44586 2.59368 5.49025 2.52151 5.56718C2.44952 5.64391 2.41 5.74682 2.41 5.85302C2.41 5.90572 2.41973 5.95802 2.43876 6.00699C2.45779 6.05596 2.48582 6.10082 2.52151 6.13886L3.76897 7.46853C3.92092 7.63049 4.1691 7.63049 4.32104 7.46853L7.47849 4.103C7.55048 4.02626 7.59 3.92335 7.59 3.81716C7.59 3.71096 7.55048 3.60805 7.47849 3.53131C7.40632 3.45439 7.30716 3.41 7.20245 3.41C7.09776 3.41 6.99862 3.45437 6.92645 3.53128C6.92644 3.53129 6.92643 3.5313 6.92642 3.53131L4.04355 6.60107Z"
          fill="#6C65D9"
          stroke="#6C65D9"
          stroke-width="0.18"
        />
        <rect x="0.5" y="1" width="9" height="9" rx="4.5" stroke="#252A38" />
      </svg>
    </Box>
  );
};
export const CheckMarkIconTwo = () => {
  return (
    <Box sx={commonIconSizes}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="1" width="9" height="9" rx="4.5" fill="#1B1D28" />
        <path
          d="M4.04355 6.60107L3.07358 5.56718C3.00141 5.49025 2.90225 5.44586 2.79755 5.44586C2.69284 5.44586 2.59368 5.49025 2.52151 5.56718C2.44952 5.64391 2.41 5.74682 2.41 5.85302C2.41 5.90572 2.41973 5.95802 2.43876 6.00699C2.45779 6.05596 2.48582 6.10082 2.52151 6.13886L3.76897 7.46853C3.92092 7.63049 4.1691 7.63049 4.32104 7.46853L7.47849 4.103C7.55048 4.02626 7.59 3.92335 7.59 3.81716C7.59 3.71096 7.55048 3.60805 7.47849 3.53131C7.40632 3.45439 7.30716 3.41 7.20245 3.41C7.09776 3.41 6.99862 3.45437 6.92645 3.53128C6.92644 3.53129 6.92643 3.5313 6.92642 3.53131L4.04355 6.60107Z"
          fill="#6C65D9"
          stroke="#6C65D9"
          stroke-width="0.18"
        />
        <rect x="0.5" y="1" width="9" height="9" rx="4.5" stroke="#1B1D28" />
      </svg>
    </Box>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11.2988C1 10.5032 1.31607 9.74012 1.87868 9.17751C2.44129 8.6149 3.20435 8.29883 4 8.29883H10C10.7956 8.29883 11.5587 8.6149 12.1213 9.17751C12.6839 9.74012 13 10.5032 13 11.2988C13 11.6967 12.842 12.0782 12.5607 12.3595C12.2794 12.6408 11.8978 12.7988 11.5 12.7988H2.5C2.10218 12.7988 1.72064 12.6408 1.43934 12.3595C1.15804 12.0782 1 11.6967 1 11.2988Z"
        stroke="#606479"
        stroke-linejoin="round"
      />
      <path
        d="M7 5.29883C8.24264 5.29883 9.25 4.29147 9.25 3.04883C9.25 1.80619 8.24264 0.798828 7 0.798828C5.75736 0.798828 4.75 1.80619 4.75 3.04883C4.75 4.29147 5.75736 5.29883 7 5.29883Z"
        stroke="#606479"
      />
    </svg>
  );
};

export const GoogleIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1099 5.43395C11.8131 4.84922 13.6652 4.86531 15.358 5.47952C16.2877 5.82761 17.1394 6.35583 17.8645 7.03389C17.6181 7.29747 17.3583 7.54381 17.107 7.79999C16.6291 8.27706 16.1516 8.75249 15.6746 9.22627C15.199 8.77139 14.6237 8.43397 13.9946 8.24093C13.1895 7.99785 12.3331 7.98121 11.5192 8.19283C10.7053 8.40445 9.9654 8.83615 9.38071 9.44058C8.87035 9.95978 8.48384 10.5875 8.25003 11.277L5.69678 9.30017C6.61069 7.48784 8.19307 6.10155 10.1099 5.43395Z"
        fill="#E33629"
      />
      <path
        d="M5.01918 11.2587C5.15631 10.5785 5.38416 9.91982 5.6966 9.30029L8.24986 11.2821C7.91594 12.2657 7.91594 13.332 8.24986 14.3157C7.39918 14.9726 6.5481 15.6327 5.6966 16.2962C4.91467 14.7397 4.6762 12.9664 5.01918 11.2587Z"
        fill="#F8BD00"
      />
      <path
        d="M12.6568 11.3386H19.9877C20.2383 12.7143 20.1705 14.1292 19.7894 15.4746C19.4387 16.7118 18.7574 17.83 17.8187 18.709C16.9947 18.066 16.1671 17.428 15.3431 16.7851C15.7516 16.5095 16.1003 16.1543 16.3682 15.7408C16.6361 15.3272 16.8178 14.8638 16.9024 14.3784H12.6568C12.6556 13.366 12.6568 12.3523 12.6568 11.3386Z"
        fill="#587DBD"
      />
      <path
        d="M5.69556 16.2962C6.54705 15.6393 7.39814 14.9791 8.24881 14.3157C8.57793 15.2815 9.20386 16.1187 10.0372 16.7076C10.5569 17.0751 11.1475 17.3301 11.7714 17.4564C12.3861 17.5708 13.0166 17.5708 13.6312 17.4564C14.2441 17.3528 14.8286 17.1221 15.3469 16.779C16.1709 17.422 16.9986 18.06 17.8226 18.7029C16.9209 19.5228 15.8217 20.0945 14.6326 20.362C13.3201 20.6705 11.9524 20.6557 10.6469 20.3188C9.61437 20.0432 8.64994 19.5572 7.81403 18.8913C6.92936 18.1888 6.20674 17.3036 5.69556 16.2962Z"
        fill="#319F43"
      />
    </svg>
  );
};

export const AppleLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0499 21.0788C16.0699 22.0288 14.9999 21.8788 13.9699 21.4288C12.8799 20.9688 11.8799 20.9488 10.7299 21.4288C9.28992 22.0488 8.52992 21.8688 7.66992 21.0788C2.78992 16.0488 3.50992 8.38883 9.04992 8.10883C10.3999 8.17883 11.3399 8.84883 12.1299 8.90883C13.3099 8.66883 14.4399 7.97883 15.6999 8.06883C17.2099 8.18883 18.3499 8.78883 19.0999 9.86883C15.9799 11.7388 16.7199 15.8488 19.5799 16.9988C19.0099 18.4988 18.2699 19.9888 17.0399 21.0888L17.0499 21.0788ZM12.0299 8.04883C11.8799 5.81883 13.6899 3.97883 15.7699 3.79883C16.0599 6.37883 13.4299 8.29883 12.0299 8.04883Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="9" fill="#28982D" />
      <path
        d="M7.46962 11.05L5.81271 9.39431C5.72343 9.30509 5.60234 9.25497 5.47607 9.25497C5.34981 9.25497 5.22872 9.30509 5.13944 9.39431C5.05016 9.48352 5 9.60453 5 9.7307C5 9.79317 5.01231 9.85504 5.03624 9.91276C5.06016 9.97047 5.09523 10.0229 5.13944 10.0671L7.13538 12.0616C7.3216 12.2477 7.62242 12.2477 7.80865 12.0616L12.8606 7.0133C12.9498 6.92408 13 6.80308 13 6.67691C13 6.55073 12.9498 6.42973 12.8606 6.34051C12.7713 6.25129 12.6502 6.20117 12.5239 6.20117C12.3977 6.20117 12.2766 6.25129 12.1873 6.34051L7.46962 11.05Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};

export const CoinIcon = () => {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1618_2265)">
        <path
          d="M24.5002 48.201C37.0186 48.201 47.1668 38.0528 47.1668 25.5343C47.1668 13.0159 37.0186 2.86768 24.5002 2.86768C11.9817 2.86768 1.8335 13.0159 1.8335 25.5343C1.8335 38.0528 11.9817 48.201 24.5002 48.201Z"
          fill="#F4900C"
        />
        <path
          d="M24.5002 45.5345C37.0186 45.5345 47.1668 35.3863 47.1668 22.8678C47.1668 10.3494 37.0186 0.201172 24.5002 0.201172C11.9817 0.201172 1.8335 10.3494 1.8335 22.8678C1.8335 35.3863 11.9817 45.5345 24.5002 45.5345Z"
          fill="#FFCC4D"
        />
        <path
          d="M24.5002 42.868C34.8095 42.868 43.1668 34.5107 43.1668 24.2013C43.1668 13.892 34.8095 5.53467 24.5002 5.53467C14.1908 5.53467 5.8335 13.892 5.8335 24.2013C5.8335 34.5107 14.1908 42.868 24.5002 42.868Z"
          fill="#FFE8B6"
        />
        <path
          d="M24.5002 41.5345C34.8095 41.5345 43.1668 33.1772 43.1668 22.8678C43.1668 12.5585 34.8095 4.20117 24.5002 4.20117C14.1908 4.20117 5.8335 12.5585 5.8335 22.8678C5.8335 33.1772 14.1908 41.5345 24.5002 41.5345Z"
          fill="#FFAC33"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.5834 16.1118L24.5001 23.7897L32.4167 16.1118V30.6162H28.6597V24.9361L24.5001 28.9702L20.3405 24.9361V30.6162H16.5834V16.1118Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.7529 31.9868V15.4155H15.51V31.9868H11.7529Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.4902 31.9868V15.4155H37.2472V31.9868H33.4902Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1618_2265">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.5 0.201172)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CoinIconSmall = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1595_844)">
        <path
          d="M18.5 36.2012C27.8888 36.2012 35.5 28.59 35.5 19.2012C35.5 9.81233 27.8888 2.20117 18.5 2.20117C9.11116 2.20117 1.5 9.81233 1.5 19.2012C1.5 28.59 9.11116 36.2012 18.5 36.2012Z"
          fill="#F4900C"
        />
        <path
          d="M18.5 34.2012C27.8888 34.2012 35.5 26.59 35.5 17.2012C35.5 7.81233 27.8888 0.201172 18.5 0.201172C9.11116 0.201172 1.5 7.81233 1.5 17.2012C1.5 26.59 9.11116 34.2012 18.5 34.2012Z"
          fill="#FFCC4D"
        />
        <path
          d="M18.5 32.2012C26.232 32.2012 32.5 25.9332 32.5 18.2012C32.5 10.4692 26.232 4.20117 18.5 4.20117C10.768 4.20117 4.5 10.4692 4.5 18.2012C4.5 25.9332 10.768 32.2012 18.5 32.2012Z"
          fill="#FFE8B6"
        />
        <path
          d="M18.5 31.2012C26.232 31.2012 32.5 24.9332 32.5 17.2012C32.5 9.46919 26.232 3.20117 18.5 3.20117C10.768 3.20117 4.5 9.46919 4.5 17.2012C4.5 24.9332 10.768 31.2012 18.5 31.2012Z"
          fill="#FFAC33"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1825 11.6445L18.5002 17.7717L24.8178 11.6445V23.2194H21.8196V18.6865L18.5002 21.9059L15.1807 18.6865V23.2194H12.1825V11.6445Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.32764 24.3132V11.0889H11.3259V24.3132H8.32764Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.6745 24.3132V11.0889H28.6727V24.3132H25.6745Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1595_844">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(0.5 0.201172)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CoinIconXsmall = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1618_2330)">
        <path
          d="M9.49365 18.2012C14.1881 18.2012 17.9937 14.3956 17.9937 9.70117C17.9937 5.00675 14.1881 1.20117 9.49365 1.20117C4.79923 1.20117 0.993652 5.00675 0.993652 9.70117C0.993652 14.3956 4.79923 18.2012 9.49365 18.2012Z"
          fill="#F4900C"
        />
        <path
          d="M9.49365 17.2012C14.1881 17.2012 17.9937 13.3956 17.9937 8.70117C17.9937 4.00675 14.1881 0.201172 9.49365 0.201172C4.79923 0.201172 0.993652 4.00675 0.993652 8.70117C0.993652 13.3956 4.79923 17.2012 9.49365 17.2012Z"
          fill="#FFCC4D"
        />
        <path
          d="M9.49365 16.2012C13.3596 16.2012 16.4937 13.0672 16.4937 9.20117C16.4937 5.33518 13.3596 2.20117 9.49365 2.20117C5.62766 2.20117 2.49365 5.33518 2.49365 9.20117C2.49365 13.0672 5.62766 16.2012 9.49365 16.2012Z"
          fill="#FFE8B6"
        />
        <path
          d="M9.49365 15.7012C13.3596 15.7012 16.4937 12.5672 16.4937 8.70117C16.4937 4.83518 13.3596 1.70117 9.49365 1.70117C5.62766 1.70117 2.49365 4.83518 2.49365 8.70117C2.49365 12.5672 5.62766 15.7012 9.49365 15.7012Z"
          fill="#FFAC33"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.62492 5.95105L9.49365 8.73326L12.3624 5.95105V11.207H11.001V9.14866L9.49365 10.6105L7.98635 9.14866V11.207H6.62492V5.95105Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.87451 11.7036V5.69873H6.23594V11.7036H4.87451Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.7514 11.7036V5.69873H14.1128V11.7036H12.7514Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1618_2330">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.493652)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CoinIconXsmallForShots = () => {
  return (
    <Box sx={commonIconSizes}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1618_2330)">
          <path
            d="M9.49365 18.2012C14.1881 18.2012 17.9937 14.3956 17.9937 9.70117C17.9937 5.00675 14.1881 1.20117 9.49365 1.20117C4.79923 1.20117 0.993652 5.00675 0.993652 9.70117C0.993652 14.3956 4.79923 18.2012 9.49365 18.2012Z"
            fill="#F4900C"
          />
          <path
            d="M9.49365 17.2012C14.1881 17.2012 17.9937 13.3956 17.9937 8.70117C17.9937 4.00675 14.1881 0.201172 9.49365 0.201172C4.79923 0.201172 0.993652 4.00675 0.993652 8.70117C0.993652 13.3956 4.79923 17.2012 9.49365 17.2012Z"
            fill="#FFCC4D"
          />
          <path
            d="M9.49365 16.2012C13.3596 16.2012 16.4937 13.0672 16.4937 9.20117C16.4937 5.33518 13.3596 2.20117 9.49365 2.20117C5.62766 2.20117 2.49365 5.33518 2.49365 9.20117C2.49365 13.0672 5.62766 16.2012 9.49365 16.2012Z"
            fill="#FFE8B6"
          />
          <path
            d="M9.49365 15.7012C13.3596 15.7012 16.4937 12.5672 16.4937 8.70117C16.4937 4.83518 13.3596 1.70117 9.49365 1.70117C5.62766 1.70117 2.49365 4.83518 2.49365 8.70117C2.49365 12.5672 5.62766 15.7012 9.49365 15.7012Z"
            fill="#FFAC33"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.62492 5.95105L9.49365 8.73326L12.3624 5.95105V11.207H11.001V9.14866L9.49365 10.6105L7.98635 9.14866V11.207H6.62492V5.95105Z"
            fill="#F9F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.87451 11.7036V5.69873H6.23594V11.7036H4.87451Z"
            fill="#F9F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7514 11.7036V5.69873H14.1128V11.7036H12.7514Z"
            fill="#F9F9F9"
          />
        </g>
        <defs>
          <clipPath id="clip0_1618_2330">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(0.493652)"
            />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
};

export const FreeCreditCoinIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3050_7810)">
        <path
          d="M9 18.2012C13.6944 18.2012 17.5 14.3956 17.5 9.70117C17.5 5.00675 13.6944 1.20117 9 1.20117C4.30558 1.20117 0.5 5.00675 0.5 9.70117C0.5 14.3956 4.30558 18.2012 9 18.2012Z"
          fill="#0E6634"
        />
        <path
          d="M9 17.2012C13.6944 17.2012 17.5 13.3956 17.5 8.70117C17.5 4.00675 13.6944 0.201172 9 0.201172C4.30558 0.201172 0.5 4.00675 0.5 8.70117C0.5 13.3956 4.30558 17.2012 9 17.2012Z"
          fill="#6DCB96"
        />
        <path
          d="M9 16.2012C12.866 16.2012 16 13.0672 16 9.20117C16 5.33518 12.866 2.20117 9 2.20117C5.13401 2.20117 2 5.33518 2 9.20117C2 13.0672 5.13401 16.2012 9 16.2012Z"
          fill="#ADE4C5"
        />
        <path
          d="M9 15.7012C12.866 15.7012 16 12.5672 16 8.70117C16 4.83518 12.866 1.70117 9 1.70117C5.13401 1.70117 2 4.83518 2 8.70117C2 12.5672 5.13401 15.7012 9 15.7012Z"
          fill="#18AA57"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.84149 5.92285L9.00033 8.98642L12.1592 5.92285V11.7103H10.6601V9.44384L9.00033 11.0535L7.3406 9.44384V11.7103H5.84149V5.92285Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.91406 12.2572V5.64502H5.41317V12.2572H3.91406Z"
          fill="#F9F9F9"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5875 12.2572V5.64502H14.0866V12.2572H12.5875Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_3050_7810">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.201172)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MovieColaIcon = ({
  height,
  width,
}: {
  height: number;
  width: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.42871 22.015V7.39844L18.0001 15.8796L26.5716 7.39844V22.015"
        stroke="#6C65D9"
        stroke-width="5"
      />
      <path d="M2.57129 0V24" stroke="#6C65D9" stroke-width="5" />
      <path d="M33.4287 0V24" stroke="#6C65D9" stroke-width="5" />
    </svg>
  );
};

export const CreditPricingLogo = () => {
  return (
    <svg
      width="27"
      height="17"
      viewBox="0 0 27 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.58343 0.89747L13.5001 8.57536L21.4167 0.89747V15.4019H17.6597V9.72173L13.5001 13.7559L9.34048 9.72173V15.4019H5.58343V0.89747Z"
        fill="#6C65D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.75293 16.7725V0.201172H4.50998V16.7725H0.75293Z"
        fill="#6C65D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.4902 16.7725V0.201172H26.2472V16.7725H22.4902Z"
        fill="#6C65D9"
      />
    </svg>
  );
};

export const EditProfileIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2131_1664)">
        <path
          d="M3 13.5C3 12.7044 3.31607 11.9413 3.87868 11.3787C4.44129 10.8161 5.20435 10.5 6 10.5H12C12.7956 10.5 13.5587 10.8161 14.1213 11.3787C14.6839 11.9413 15 12.7044 15 13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H4.5C4.10218 15 3.72064 14.842 3.43934 14.5607C3.15804 14.2794 3 13.8978 3 13.5Z"
          stroke="#F9F9F9"
          stroke-linejoin="round"
        />
        <path
          d="M15.788 5.49923C15.8607 5.42656 15.9593 5.38574 16.062 5.38574C16.1648 5.38574 16.2634 5.42656 16.3361 5.49923L17.8865 7.04967C17.9592 7.12236 18 7.22093 18 7.32371C18 7.42649 17.9592 7.52506 17.8865 7.59775L12.8476 12.6367C12.7749 12.7094 12.6763 12.7502 12.5735 12.7502H11.0231C10.9203 12.7502 10.8217 12.7094 10.749 12.6367C10.6763 12.564 10.6355 12.4654 10.6355 12.3626V10.8122C10.6355 10.7094 10.6764 10.6108 10.7491 10.5382L14.6252 6.66206L15.788 5.49923Z"
          fill="#252A38"
        />
        <path
          d="M15.4344 5.14568L15.4345 5.14562C15.6009 4.97922 15.8267 4.88574 16.062 4.88574C16.2974 4.88574 16.5231 4.97922 16.6896 5.14562L16.6896 5.14568L18.2401 6.69611L18.2401 6.69617C18.4065 6.86262 18.5 7.08835 18.5 7.32371C18.5 7.55907 18.4065 7.7848 18.2401 7.95125L18.2401 7.9513L13.2012 12.9902C13.0348 13.1566 12.809 13.2502 12.5737 13.2502H12.5735H11.0231C10.7877 13.2502 10.5619 13.1567 10.3955 12.9903C10.229 12.8238 10.1355 12.598 10.1355 12.3626V10.8122V10.8121C10.1355 10.5767 10.2291 10.351 10.3955 10.1846C10.3955 10.1846 10.3956 10.1846 10.3956 10.1845L14.2716 6.3085M15.4344 5.14568L14.2716 6.3085M15.4344 5.14568L14.2716 6.3085M15.4344 5.14568L14.2716 6.3085M11.9107 11.1798L14.8992 8.19128L15.1945 8.48654L12.206 11.475H11.9107V11.1798Z"
          fill="#F9F9F9"
          stroke="#252A38"
        />
        <path
          d="M9 7.5C10.2426 7.5 11.25 6.49264 11.25 5.25C11.25 4.00736 10.2426 3 9 3C7.75736 3 6.75 4.00736 6.75 5.25C6.75 6.49264 7.75736 7.5 9 7.5Z"
          stroke="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_2131_1664">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TermsAndConditionIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V14C15 14.5523 14.5523 15 14 15H4C3.44772 15 3 14.5523 3 14V4ZM5.2 4.2C4.64771 4.2 4.2 4.64772 4.2 5.2V12.8C4.2 13.3523 4.64772 13.8 5.2 13.8H12.8C13.3523 13.8 13.8 13.3523 13.8 12.8V5.2C13.8 4.64771 13.3523 4.2 12.8 4.2H5.2ZM5.4 6.9C5.4 6.56863 5.66863 6.3 6 6.3H12C12.3314 6.3 12.6 6.56863 12.6 6.9C12.6 7.23137 12.3314 7.5 12 7.5H6C5.66863 7.5 5.4 7.23137 5.4 6.9ZM5.4 9.3C5.4 8.96863 5.66863 8.7 6 8.7H9.6C9.93137 8.7 10.2 8.96863 10.2 9.3C10.2 9.63137 9.93137 9.9 9.6 9.9H6C5.66863 9.9 5.4 9.63137 5.4 9.3Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};
export const LogOutIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 6V4.5C10.5 4.10218 10.342 3.72064 10.0607 3.43934C9.77936 3.15804 9.39782 3 9 3H3.75C3.35218 3 2.97064 3.15804 2.68934 3.43934C2.40804 3.72064 2.25 4.10218 2.25 4.5V13.5C2.25 13.8978 2.40804 14.2794 2.68934 14.5607C2.97064 14.842 3.35218 15 3.75 15H9C9.39782 15 9.77936 14.842 10.0607 14.5607C10.342 14.2794 10.5 13.8978 10.5 13.5V12"
        stroke="#FF0000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.75 9H15.75M15.75 9L13.5 6.75M15.75 9L13.5 11.25"
        stroke="#FF0000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SelectAllIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 8.5V3.5H8.5V8.5H3.5ZM4.5 7.5H7.5V4.5H4.5V7.5ZM3.5 10.5V9.5H4.5V10.5H3.5ZM1.5 2.5V1.5H2.5V2.5H1.5ZM3.5 2.5V1.5H4.5V2.5H3.5ZM5.5 10.5V9.5H6.5V10.5H5.5ZM5.5 2.5V1.5H6.5V2.5H5.5ZM7.5 2.5V1.5H8.5V2.5H7.5ZM7.5 10.5V9.5H8.5V10.5H7.5ZM9.5 2.5V1.5H10.5V2.5H9.5ZM1.5 10.5V9.5H2.5V10.5H1.5ZM1.5 8.5V7.5H2.5V8.5H1.5ZM1.5 6.5V5.5H2.5V6.5H1.5ZM1.5 4.5V3.5H2.5V4.5H1.5ZM9.5 10.5V9.5H10.5V10.5H9.5ZM9.5 8.5V7.5H10.5V8.5H9.5ZM9.5 6.5V5.5H10.5V6.5H9.5ZM9.5 4.5V3.5H10.5V4.5H9.5Z"
        fill="#606479"
      />
    </svg>
  );
};

export const RotateIcon = () => {
  return (
    <svg
      width="128"
      height="129"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.9999 5.82422H15.9999C13.1709 5.82422 10.4578 6.94803 8.45745 8.94841C6.45706 10.9488 5.33325 13.6619 5.33325 16.4909V85.8242C5.33325 88.6532 6.45706 91.3663 8.45745 93.3667C10.4578 95.3671 13.1709 96.4909 15.9999 96.4909H47.9999C50.8289 96.4909 53.542 95.3671 55.5424 93.3667C57.5428 91.3663 58.6666 88.6532 58.6666 85.8242V16.4909C58.6666 13.6619 57.5428 10.9488 55.5424 8.94841C53.542 6.94803 50.8289 5.82422 47.9999 5.82422ZM47.9999 85.8242H15.9999V16.4909H47.9999V85.8242ZM112 69.8242H70.3333C69.781 69.8242 69.3333 70.2719 69.3333 70.8242V79.4909C69.3333 80.0432 69.781 80.4909 70.3333 80.4909H112V112.491H42.6666V108.158C42.6666 107.605 42.2189 107.158 41.6666 107.158H32.9999C32.4476 107.158 31.9999 107.605 31.9999 108.158V112.491C31.9999 115.32 33.1237 118.033 35.1241 120.033C37.1245 122.034 39.8376 123.158 42.6666 123.158H112C114.829 123.158 117.542 122.034 119.542 120.033C121.543 118.033 122.667 115.32 122.667 112.491V80.4909C122.667 77.6619 121.543 74.9488 119.542 72.9484C117.542 70.948 114.829 69.8242 112 69.8242ZM122.639 52.2061C122.664 52.9491 121.884 53.4331 121.219 53.1006L103.165 44.0737C102.421 43.7012 102.431 42.6347 103.183 42.2765L111.52 38.3042C108.457 31.0576 103.33 24.8724 96.7765 20.5194C90.5007 16.3506 83.1829 14.0387 75.6648 13.8384C75.1134 13.8237 74.6666 13.3776 74.6666 12.826V6.82422C74.6666 6.27193 75.1146 5.82313 75.6667 5.83463C88.035 6.0921 99.842 11.1174 108.608 19.8831C117.227 28.5027 122.23 40.0631 122.639 52.2061Z"
        fill="#F9F9F9"
      />
    </svg>
  );
};

export const NoStoryBoardImage = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 3.414L28.586 2L2 28.586L3.414 30L5.414 28H26C26.5302 27.9992 27.0384 27.7882 27.4133 27.4133C27.7882 27.0384 27.9992 26.5302 28 26V5.414L30 3.414ZM26 26H7.414L15.207 18.207L17.586 20.586C17.9611 20.9609 18.4697 21.1716 19 21.1716C19.5303 21.1716 20.0389 20.9609 20.414 20.586L22 19L26 22.997V26ZM26 20.168L23.414 17.582C23.0389 17.2071 22.5303 16.9964 22 16.9964C21.4697 16.9964 20.9611 17.2071 20.586 17.582L19 19.168L16.623 16.791L26 7.414V20.168ZM6 22V19L11 14.003L12.373 15.377L13.789 13.961L12.414 12.586C12.0389 12.2111 11.5303 12.0004 11 12.0004C10.4697 12.0004 9.96106 12.2111 9.586 12.586L6 16.172V6H22V4H6C5.46973 4.00053 4.96133 4.21141 4.58637 4.58637C4.21141 4.96133 4.00053 5.46973 4 6V22H6Z"
      fill="#F9F9F9"
    />
  </svg>
);
